var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGirlLegs5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1160,
    height: 1258,
    viewBox: "0 0 1160 1258",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Girl / Legs / 5"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group 17"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Shoes"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Shoes_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M441.323 1192.69L392.653 1195.13C392.653 1195.13 355.885 1204.18 330.485 1254.13H446.525L441.323 1192.69ZM797.083 1254.71C762.647 1218.99 671.043 1194.98 671.043 1194.98L636.713 1193.93L632.229 1255L797.083 1254.71Z",
    fill: "#0D0B6D"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skin color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skin",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M371.115 1227.25C399.159 1226.7 418.357 1211.59 428.315 1201.15L439.745 1203.24L479.239 591.106L351.885 650.108L400.355 1190.29C392.247 1195.73 345.588 1227.76 371.115 1227.25ZM752.671 1225.07L687.012 1196.57C683.243 1171.56 667.303 1062.71 652.599 916.485C639.409 785.293 627.925 665.217 627.925 665.217L518.385 670.331L638.173 1202.03H651.182C672.025 1212.65 712.433 1229.47 752.671 1225.07Z",
    fill: "#E576C6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Skirt color"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Skirt",
    d: "M398.6 101.999C398.6 101.999 364.654 118.231 335.116 206.331C295.582 324.247 284 681.409 284 681.409H664.664L566.566 104.559L398.6 101.999Z",
    fill: "#2F2F3D"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGirlLegs5);
export default __webpack_public_path__ + "static/media/Girl-Legs-5.8b2a37ec.svg";
export { ForwardRef as ReactComponent };